import * as httpStatusTypes from '../consts/httpStatusTypes';

const getIsNotAuthorized = (status) => status === httpStatusTypes.NOT_AUTHORIZED;

export default {
    getIsNotAuthorized,
};
